import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";

/**
 * DataSourceCard component
 * @param {Object} props - The props for the component
 * @param {Object} props.card - The card data for the component
 * @param {string} props.className - The className for the component
 * @returns {JSX.Element} - Rendered component
 */

const DataSourceCard = ({ card, className = null }) => {
    const { title } = card ?? {};
    return (
        <div className={`border border-stone border-opacity-50 rounded h-full p-5 lg:p-7.25 text-center ${className}`}>
            {/* Check if media exists */}

            <div className="h-20 mb-5 lg:mb-10 overflow-hidden flex justify-center">
                {card?.media && (
                    <Media
                        media={card.media}
                        className="w-auto h-[90px] object-scale-down object-left-top lg:group-hover/resource-card:scale-110 transition-transform duration-300"
                    />
                )}
            </div>

            {title && (
                <p className="title-5 text-blue text-base lg:text-xl leading-tight line-clamp-3">
                    {/* Set inner HTML */}
                    {/* eslint-disable-next-line react/no-danger */}
                    <span dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }} />
                </p>
            )}
        </div>
    );
};

export default DataSourceCard;
